(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-client-core.js', './ktor-ktor-http.js', './compose-imageLoader-image-loader.js', './okio-parent-okio.js', './ktor-ktor-io.js', './kotlinx-io-kotlinx-io-core.js', './compose-multiplatform-core-compose-ui-ui-geometry.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-http.js'), require('./compose-imageLoader-image-loader.js'), require('./okio-parent-okio.js'), require('./ktor-ktor-io.js'), require('./kotlinx-io-kotlinx-io-core.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    if (typeof globalThis['compose-imageLoader-image-loader'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'compose-imageLoader-image-loader' was not found. Please, check whether 'compose-imageLoader-image-loader' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    if (typeof globalThis['okio-parent-okio'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'okio-parent-okio' was not found. Please, check whether 'okio-parent-okio' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    if (typeof globalThis['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'kotlinx-io-kotlinx-io-core' was not found. Please, check whether 'kotlinx-io-kotlinx-io-core' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-ktor-network'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-imageLoader-extension-ktor-network'.");
    }
    globalThis['compose-imageLoader-extension-ktor-network'] = factory(typeof globalThis['compose-imageLoader-extension-ktor-network'] === 'undefined' ? {} : globalThis['compose-imageLoader-extension-ktor-network'], globalThis['kotlin-kotlin-stdlib'], globalThis['ktor-ktor-client-core'], globalThis['ktor-ktor-http'], globalThis['compose-imageLoader-image-loader'], globalThis['okio-parent-okio'], globalThis['ktor-ktor-io'], globalThis['kotlinx-io-kotlinx-io-core'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry']);
  }
}(function (_, kotlin_kotlin, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_http, kotlin_io_github_qdsfdhvh_image_loader, kotlin_com_squareup_okio_okio, kotlin_io_ktor_ktor_io, kotlin_org_jetbrains_kotlinx_kotlinx_io_core, kotlin_org_jetbrains_compose_ui_ui_geometry) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.d1;
  var contentType = kotlin_io_ktor_ktor_http.$_$.p1;
  var mimeType = kotlin_io_github_qdsfdhvh_image_loader.$_$.n;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var Url = kotlin_io_ktor_ktor_http.$_$.f1;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var HttpResponse = kotlin_io_ktor_ktor_client_core.$_$.y;
  var isSuccess = kotlin_io_ktor_ktor_http.$_$.w1;
  var bodyAsChannel = kotlin_io_ktor_ktor_client_core.$_$.e;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var ImageSourceFrom_Network_getInstance = kotlin_io_github_qdsfdhvh_image_loader.$_$.w;
  var extraData = kotlin_io_github_qdsfdhvh_image_loader.$_$.l;
  var OfSource = kotlin_io_github_qdsfdhvh_image_loader.$_$.b;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var lazy = kotlin_kotlin.$_$.to;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.q;
  var url = kotlin_io_ktor_ktor_client_core.$_$.x;
  var Companion_getInstance = kotlin_io_ktor_ktor_http.$_$.h;
  var headers = kotlin_io_ktor_ktor_client_core.$_$.t;
  var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.z;
  var RuntimeException = kotlin_kotlin.$_$.rn;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.i6;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Buffer = kotlin_com_squareup_okio_okio.$_$.c;
  var Long = kotlin_kotlin.$_$.kn;
  var readRemaining = kotlin_io_ktor_ktor_io.$_$.l;
  var readByteArray = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.k;
  var toImageSource = kotlin_io_github_qdsfdhvh_image_loader.$_$.o;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var Companion_getInstance_0 = kotlin_io_github_qdsfdhvh_image_loader.$_$.u;
  var Scale_FILL_getInstance = kotlin_io_github_qdsfdhvh_image_loader.$_$.x;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var Size__toString_impl_o87ni8 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.i1;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var startsWith = kotlin_kotlin.$_$.dl;
  var Url_0 = kotlin_io_ktor_ktor_http.$_$.e1;
  var Js_instance = kotlin_io_ktor_ktor_client_core.$_$.a;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Factory, 'Factory');
  initMetadataForCompanion(Companion);
  initMetadataForLambda(KtorUrlFetcher$fetch$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(KtorUrlFetcher, 'KtorUrlFetcher', VOID, VOID, VOID, [0]);
  initMetadataForClass(KtorUrlRequestException, 'KtorUrlRequestException', VOID, RuntimeException);
  initMetadataForCoroutine($channelToImageSourceCOROUTINE$, CoroutineImpl);
  initMetadataForClass(KtorUrlKeyer, 'KtorUrlKeyer', KtorUrlKeyer);
  initMetadataForClass(KtorUrlMapper, 'KtorUrlMapper', KtorUrlMapper);
  initMetadataForClass(KtorRequestData, 'KtorRequestData');
  //endregion
  function setupKtorComponents(_this__u8e3s4, httpClient) {
    httpClient = httpClient === VOID ? Companion_instance.wyg() : httpClient;
    _this__u8e3s4.ay8(new KtorUrlMapper());
    _this__u8e3s4.by8(new KtorUrlKeyer());
    _this__u8e3s4.cy8(new Factory(httpClient));
  }
  function KtorUrlFetcher$Companion$_get_defaultHttpEngineFactory_$lambda_y8lt95() {
    return new HttpClient(get_httpEngine());
  }
  function KtorUrlFetcher$fetch$slambda$lambda($response) {
    return function ($this$extraData) {
      var tmp3_safe_receiver = contentType($response);
      mimeType($this$extraData, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString());
      return Unit_instance;
    };
  }
  function _get_httpClient__2ty1zc($this) {
    var tmp0 = $this.zyg_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('httpClient', 1, tmp, KtorUrlFetcher$_get_httpClient_$ref_8n7smx(), null);
    return tmp0.u1();
  }
  function Factory(httpClient) {
    this.ayh_1 = httpClient;
  }
  protoOf(Factory).xy7 = function (data, options) {
    if (!(data instanceof Url))
      return null;
    return new KtorUrlFetcher(data, this.ayh_1, get_ktorRequestData(options));
  };
  function Companion() {
  }
  protoOf(Companion).wyg = function () {
    return KtorUrlFetcher$Companion$_get_defaultHttpEngineFactory_$lambda_y8lt95;
  };
  var Companion_instance;
  function Companion_getInstance_1() {
    return Companion_instance;
  }
  function KtorUrlFetcher$_get_httpClient_$ref_8n7smx() {
    return constructCallableReference(function (p0) {
      return _get_httpClient__2ty1zc(p0);
    }, 1, 0, 560);
  }
  function KtorUrlFetcher$fetch$lambda($it) {
    return function ($this$headers) {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $it.s1().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var key = element.t1();
        // Inline function 'kotlin.collections.component2' call
        var value = element.u1();
        $this$headers.fsq(key, value);
      }
      return Unit_instance;
    };
  }
  function KtorUrlFetcher$fetch$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KtorUrlFetcher$fetch$slambda).kyh = function (response, $completion) {
    var tmp = this.xu0(response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(KtorUrlFetcher$fetch$slambda).ja = function (p1, $completion) {
    return this.kyh(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KtorUrlFetcher$fetch$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (!isSuccess(this.jyh_1.zbq())) {
              throw new KtorUrlRequestException('code:' + this.jyh_1.zbq().yt2_1 + ', ' + this.jyh_1.zbq().zt2_1);
            }

            this.n9_1 = 1;
            suspendResult = bodyAsChannel(this.jyh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = channelToImageSource(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            var tmp_0 = ImageSourceFrom_Network_getInstance();
            return new OfSource(ARGUMENT_0, tmp_0, extraData(KtorUrlFetcher$fetch$slambda$lambda(this.jyh_1)));
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(KtorUrlFetcher$fetch$slambda).xu0 = function (response, completion) {
    var i = new KtorUrlFetcher$fetch$slambda(completion);
    i.jyh_1 = response;
    return i;
  };
  function KtorUrlFetcher$fetch$slambda_0(resultContinuation) {
    var i = new KtorUrlFetcher$fetch$slambda(resultContinuation);
    return constructCallableReference(function (response, $completion) {
      return i.kyh(response, $completion);
    }, 1);
  }
  function KtorUrlFetcher(httpUrl, httpClient, ktorRequestData) {
    this.xyg_1 = httpUrl;
    this.yyg_1 = ktorRequestData;
    this.zyg_1 = lazy(httpClient);
  }
  protoOf(KtorUrlFetcher).hy8 = function ($completion) {
    // Inline function 'io.ktor.client.request.prepareRequest' call
    var tmp0 = _get_httpClient__2ty1zc(this);
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpRequestBuilder();
    url(this_0, this.xyg_1);
    var tmp = this_0;
    var tmp0_safe_receiver = this.yyg_1;
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyh_1;
    tmp.ztr_1 = tmp0_elvis_lhs == null ? Companion_getInstance().et2_1 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = this.yyg_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.myh_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      headers(this_0, KtorUrlFetcher$fetch$lambda(tmp2_safe_receiver));
    }
    // Inline function 'io.ktor.client.request.prepareRequest' call
    var tmp_0 = new HttpStatement(this_0, tmp0);
    return tmp_0.ov2(KtorUrlFetcher$fetch$slambda_0(null), $completion);
  };
  protoOf(KtorUrlFetcher).iy8 = function ($completion) {
    return this.hy8($completion);
  };
  function KtorUrlRequestException(msg) {
    RuntimeException_init_$Init$(msg, this);
    captureStack(this, KtorUrlRequestException);
  }
  function channelToImageSource(channel, $completion) {
    var tmp = new $channelToImageSourceCOROUTINE$(channel, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $channelToImageSourceCOROUTINE$(channel, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vyh_1 = channel;
  }
  protoOf($channelToImageSourceCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.wyh_1 = new Buffer();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!!this.vyh_1.qsc()) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = readRemaining(this.vyh_1, new Long(2048, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var packet = suspendResult;
            while (!packet.ms7()) {
              var bytes = readByteArray(packet);
              this.wyh_1.jvt(bytes);
            }

            this.n9_1 = 1;
            continue $sm;
          case 3:
            return toImageSource(this.wyh_1);
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function memorySuffix($this, options) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    if (options.yy9_1) {
      this_0.q('-allowInexactSize');
    }
    if (!options.zy9_1) {
      this_0.q('-premultipliedAlpha');
    }
    if (!options.bya_1.equals(Companion_getInstance_0().wy0_1)) {
      this_0.q('-imageConfig=' + options.bya_1.toString());
    }
    if (!options.dya_1.equals(Scale_FILL_getInstance())) {
      this_0.q('-scale=fit');
    }
    if (!options.gya_1) {
      this_0.q('-noPlay');
    }
    if (!(options.jya_1 === 4096)) {
      this_0.q('-maxSize' + options.jya_1);
    }
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    var this_1 = options.cya_1;
    if (!equalsLong(_Size___get_packedValue__impl__7rlt1o(this_1), new Long(2143289344, 2143289344))) {
      this_0.q('-size=' + Size__toString_impl_o87ni8(options.cya_1));
    }
    return this_0.toString();
  }
  function KtorUrlKeyer() {
  }
  protoOf(KtorUrlKeyer).vy7 = function (data, options, type) {
    if (!(data instanceof Url))
      return null;
    var tmp;
    switch (type.a1_1) {
      case 0:
        tmp = memorySuffix(this, options);
        break;
      case 1:
        tmp = '';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var playAnimeSuffix = tmp;
    return data.toString() + playAnimeSuffix;
  };
  function isApplicable($this, data) {
    return startsWith(data, 'http:') || startsWith(data, 'https:');
  }
  function KtorUrlMapper() {
  }
  protoOf(KtorUrlMapper).uy7 = function (data, options) {
    if (!(typeof data === 'string'))
      return null;
    if (!isApplicable(this, data))
      return null;
    return Url_0(data);
  };
  function KtorRequestData() {
  }
  function get_ktorRequestData(_this__u8e3s4) {
    var tmp = _this__u8e3s4.kya_1.w2('KEY_KTOR_REQUEST_DATA');
    return tmp instanceof KtorRequestData ? tmp : null;
  }
  function get_httpEngine() {
    return Js_instance.kty();
  }
  //region block: init
  Companion_instance = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = setupKtorComponents;
  _.$_$.b = Companion_instance;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-imageLoader-extension-ktor-network.js.map
